<template>
  <div class="mb-3">
    <b for="name" v-if="label" class="form-label"> {{ label }} </b>
    <VueDatePicker v-model="internalValue" :disabled="disabled" :readonly="readonly" locale="fr"
      :cancelText="i18n.t('button.cancel')" :selectText="i18n.t('button.select')" :enable-time-picker="false"
      :max-date="maxDate" />
    <span v-if="v">
      <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
        - {{ error.$message }} <br>
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, defineProps, defineEmits, PropType } from 'vue';
import { getMonth, getYear } from "date-fns";
import i18n from "@/i18n/index"
const props = defineProps({
  modelValue: {
    type: [String, Date, null] as PropType<string | Date | null>,
    default: null,
  },
  type: { type: String, default: 'text' },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },

  label: { type: String },
  typeStyle: { type: String, default: "" },
  v: {
    type: Object,
  },

  fixedDays: { type: Number, default: 1 },
  isFixedDays: { type: Boolean, default: false },
});


const maxDate = computed(() => {
  if (props?.isFixedDays) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits for month
    return `${year}-${month}-${props?.fixedDays ?? 1}T01:00:00Z`;
  }
  return false
});

const emits = defineEmits(['update:modelValue']);

const internalValue = ref<string | Date | null>(props.modelValue);

watch(internalValue, (newValue) => {
  if (newValue instanceof Date) {
    // Emit date in YYYY-MM-DD format
    emits('update:modelValue', newValue.toISOString().split('T')[0]);
  } else {
    emits('update:modelValue', newValue); // If it's a string or null
  }
});

watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});

// In case of a range picker, you'll receive [Date, Date]
// const format = (date) => {
//   const day = date.getDate();
//   const month = date.getMonth() + 1;
//   const year = date.getFullYear();
//   return `${day}/${month}/${year}`;
// }


</script>

<style>
/* Add any necessary styles here */
</style>
